import dayjs from "dayjs";
import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/v1";

export const commissionsApi = {
    getCommissions: async (token, page = 1, limit = 20) => {
        const response = await apiFetch(`${BASE_URL}/commissions?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { status: response.status, data };
    },
    
    // Get commissions for all pages to calculate totals efficiently
    // This is expensive, avoid using it for display purposes
    getAllCommissions: async (token, maxLimit = 1000) => {
        const response = await apiFetch(`${BASE_URL}/commissions?page=1&limit=${maxLimit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { status: response.status, data };
    },
    
    // Calculate totals from raw commission data
    calculateGameTotals: (commissions) => {
        const gameSettingsTotals = {};
        const gameTotals = {};
        
        commissions.forEach(commission => {
            let settingsId, gameId, gameName;
            const amount = parseFloat(commission.amount || 0);
            
            // Extract from game object
            if (commission.game && commission.game.game_settings_id) {
                settingsId = commission.game.game_settings_id;
                gameId = commission.game.id;
                gameName = commission.game.name;
            } 
            // Extract from TransactionReceipt.game
            else if (commission.TransactionReceipt && commission.TransactionReceipt.game) {
                if (commission.TransactionReceipt.game.game_settings) {
                    settingsId = commission.TransactionReceipt.game.game_settings.id;
                } else if (commission.TransactionReceipt.game.game_settings_id) {
                    settingsId = commission.TransactionReceipt.game.game_settings_id;
                }
                gameId = commission.TransactionReceipt.game.id;
                gameName = commission.TransactionReceipt.game.name;
            }
            
            // Update settings totals
            if (settingsId) {
                if (!gameSettingsTotals[settingsId]) {
                    gameSettingsTotals[settingsId] = {
                        amount: 0,
                        count: 0
                    };
                }
                gameSettingsTotals[settingsId].amount += amount;
                gameSettingsTotals[settingsId].count += 1;
            }
            
            // Update game totals
            if (gameId) {
                if (!gameTotals[gameId]) {
                    gameTotals[gameId] = {
                        amount: 0,
                        count: 0,
                        name: gameName || 'Unknown',
                        settingsId: settingsId
                    };
                }
                gameTotals[gameId].amount += amount;
                gameTotals[gameId].count += 1;
            }
        });
        
        return {
            gameSettingsTotals,
            gameTotals
        };
    },
    
    convertCommission: async (token, amount) => {
        const response = await apiFetch(`${BASE_URL}/commissions/convert`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ amount }),
        });
        const data = await response.json();
        return { status: response.status, data };
    },
};
